/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import ArticleComp from '@components/UI/Wisdom/ArticleComp';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData, fetchHeaderMenuData, fetchHeaderTopMenuData
} from 'services/commonService';
import {
  fetchSadhguruMMMArticlePage,
  getSadhguruLandingPaths
} from 'services/sadhguruService';

/**
 * Renders the MMM Article Page
 *
 * @function
 * @param {object} footerData - data
 * @param {string} language - Current User Language
 * @param {object} headerMenuData - Header menu Data
 * @param {object} pageData - Data
 * @param {string} region - Country
 * @returns {ReactElement} MMM Article Page
 */

/**
 *
 * @param headerMenuData
 * @param region
 * @param language
 * @param footerData
 * @param pageData
 * @param page
 */
export default function MMMArticlePage({
  headerMenuData,
  region,
  language,
  footerData,
  pageData,
  page,
}) {
  // const [currentUserRegion, setCurrentUserRegion] = useState(region);
  // const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  // const [regionDropdownOpen, setRegionDropdownOpen] = useState(false);
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang(region, language);
    // const currentRegion = config.locales.find(
    //   locale => locale.region_sf === region
    // ).region;
    // setCurrentUserRegion(currentRegion);
  }, [authContext, region, language]);

  return (
    <WrapLayout>
      <HeadComponent
        data={pageData._seoMetaTags}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>

      {/* <Header
        headerMenuData={headerMenuData}
        currentUserRegion={currentUserRegion}
        region={region}
        language={language}
        availableLocals={pageData.availableLocales}
        setMobileMenuOpen={(val) => setMobileMenuOpen(val)}
        mobileMenuOpen={mobileMenuOpen}
        regionDropdownOpen={regionDropdownOpen}
        setRegionDropdownOpen={(val) => setRegionDropdownOpen(val)}
        setCurrentUserRegion={(val) => setCurrentUserRegion(val)}
      /> */}

      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <Box as="section" className="page-wrap container-article">
        <Box maxWidth="1300px" margin="0 auto" float="none">
          <ArticleComp
            articleData={pageData}
            language={language}
            pageType="sadhguru"
          />
        </Box>
      </Box>
      {/* <Footer region={region} language={language} footerData={footerData} />
      <BottomWidget region={region} /> */}
    </WrapLayout>
  );
}

export const getStaticPaths = async () => {
  const mmmArticlePaths = config.USE_LOCAL_URL
    ? [
      `/en/sadhguru/man/man-and-machine`,
      `/en/sadhguru/mystic/yantra-meaning-benefits`,
    ]
    : await getSadhguruLandingPaths('L2', '/sadhguru/');
  return {
    paths: mmmArticlePaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, mmm, mmmArticle },
  req,
}) => {
  // let ipRegion = await getCurrentIpRegion();
  const language = region;

  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale('', language),
    'isotopmenu'
  );

  const headerMenuData = await fetchHeaderMenuData(
    getLocale('', language),
    'iso_non_regional_menu'
  );
  const footerData = await fetchFooterData(
    getLocale('', language),
    'isofooter'
  );
  const pageData = await fetchSadhguruMMMArticlePage(
    '',
    language,
    mmm,
    mmmArticle,
    { preview, data: previewData }
  );

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: '',
      language,
      footerData: footerData?.data || null,
      pageData,
      page: `Sadhguru/${mmm}/${mmmArticle}`,
      isPreview: !!preview,
    }
  };
};
